/**
 * FormGrid + Field — consistent form layout for editors (drawers, modals).
 *
 * <FormGrid> is a 2-column grid (1 column on phones).
 * <Field> is one labelled control:
 *   label     string   label above the control
 *   required  bool     shows a small red asterisk
 *   hint      node     gray helper text under the control
 *   full      bool     spans both columns (textareas, tag pickers, long content)
 *
 * The controls themselves stay controlled by the screen (value/onChange), so
 * validation and save logic remain in the screen, unchanged.
 *
 * Usage:
 *   <FormGrid>
 *     <Field label="שם" required><Input value={…} onChange={…} /></Field>
 *     <Field label="טאגים" full>…</Field>
 *   </FormGrid>
 */
import React from 'react';
import styles from './FormGrid.css';

export const FormGrid = ({ children }) => <div className={styles.grid}>{children}</div>;

export const Field = ({ label, required, hint, full, children }) => (
  // <div>, not <label>: a wrapping <label> re-fires clicks on Ant Selects.
  <div className={[styles.field, full ? styles.full : ''].join(' ')}>
    {label ? (
      <span className={styles.label}>
        {label}
        {required ? <span className={styles.required}>*</span> : null}
      </span>
    ) : null}
    {children}
    {hint ? <span className={styles.hint}>{hint}</span> : null}
  </div>
);

export default FormGrid;
